import { GlobalFooter as CDXFooter } from '@cbhq/cdx-components'
import type { GlobalFooterProps } from '@cbhq/cdx-components'

type FooterProps = GlobalFooterProps & {
  renderCdxFooter?: boolean
}

export function GlobalFooter({
  legalDisclaimer,
  style = 'default',
  renderCdxFooter = false,
  ...cdxFooterProps
}: FooterProps) {
  return <CDXFooter legalDisclaimer={legalDisclaimer} {...cdxFooterProps} />
}
